export const AUDIO = {
  Format: "ogg",
  Modes: {
    word: "w",
    sentence: "s",
    both: "b",
    bothLoop: "d",
    spell: "p",
  }
};



// WEBPACK FOOTER //
// ./src/const/audio.js